<script context="module">
  import BlockQuote from "$lib/contentTypes/BlockQuote.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import Embed from "$lib/contentTypes/Embed/Embed.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import CallToActionComponent from "$lib/contentTypes/CallToActionComponent.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FundraiseUpElement from "$lib/contentTypes/FundraiseUpElement.svelte";
  import FreeRichTextComponent from "$lib/contentTypes/FreeRichTextComponent.svelte";
  import TopicHeaderComponent from "./TopicHeaderComponent.svelte";

  const CONTENT_GROUP_COMPONENT_MAP = {
    blockQuote: BlockQuote,
    callToActionComponent: CallToActionComponent,
    emailSignup: EmailSignupForm,
    embed: Embed,
    freeRichTextComponent: FreeRichTextComponent,
    fundraiseUpElement: FundraiseUpElement,
    imageComponent: ImageComponent,
    linkComponent: LinkComponent,
    topicHeaderComponent: TopicHeaderComponent
  };

  function getComponent(typename) {
    let component = CONTENT_GROUP_COMPONENT_MAP[typename];
    if (!component) {
      // eslint-disable-next-line no-console
      console.warn(`Component missing: ${typename}`);
    }
    return component;
  }
</script>

<script>
  import { setContext } from "svelte";
  import Accordion from "$lib/components/Accordion.svelte";
  import RichText from "$lib/components/RichText.svelte";
  import TwoColumnLayout from "$lib/components/TwoColumnLayout.svelte";
  import YoutubeEmbed from "$lib/contentTypes/Embed/YoutubeEmbed.svelte";
  import VideoPlaylist from "$lib/components/VideoPlaylist.svelte";
  import TimelineEvent from "$lib/components/TimelineEvent.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import YoutubeEmbedDescription from "./Embed/YoutubeEmbedDescription.svelte";

  export let data;

  const itemContentTypes = data.fields.items.map((item) => {
    return item.sys.contentType.sys.id;
  });

  const LEFT_COLUMN_INDEX = 0;
  const RIGHT_COLUMN_INDEX = 1;
  let columnLayout;
  let twoColumnClasses = {
    left: "",
    right: ""
  };

  function isTypeformEmbed(itemIndex) {
    return (
      itemContentTypes[itemIndex] === "embed" &&
      data.fields.items[itemIndex].fields.provider === "typeform"
    );
  }

  if (data.fields.formFactor === "Wide Image Layout") {
    if (itemContentTypes[LEFT_COLUMN_INDEX] === "imageComponent") {
      columnLayout = "leftWide";
    } else {
      columnLayout = "rightWide";
    }

    if (isTypeformEmbed(LEFT_COLUMN_INDEX)) {
      twoColumnClasses.left = "lg:pl-0";
    } else if (isTypeformEmbed(RIGHT_COLUMN_INDEX)) {
      twoColumnClasses.right = "lg:pr-0";
    }
  }

  setContext("containerized", true);
</script>

{#if data.fields.formFactor === "accordion"}
  <div class="w-full embedded-content">
    {#each data.fields.items as item}
      <!-- TODO: remove `isOpen` if stories refactored using interactions -->
      <Accordion label={item.fields.headline} isOpen={item.fields.isOpen}>
        <RichText node={item.fields.body} />
      </Accordion>
    {/each}
  </div>
{:else if data.fields.formFactor === "Wide Image Layout"}
  <TwoColumnLayout
    {columnLayout}
    leftColumnClass={twoColumnClasses.left}
    rightColumnClass={twoColumnClasses.right}
  >
    <svelte:component
      this={getComponent(itemContentTypes[LEFT_COLUMN_INDEX])}
      slot="left"
      data={data.fields.items[LEFT_COLUMN_INDEX]}
    />
    <svelte:component
      this={getComponent(itemContentTypes[RIGHT_COLUMN_INDEX])}
      slot="right"
      data={data.fields.items[RIGHT_COLUMN_INDEX]}
    />
  </TwoColumnLayout>
{:else if data.fields.formFactor === "Video"}
  <div class={"aspect-video px-24 lg:px-0"}>
    <YoutubeEmbed data={data.fields.items[0]} />
  </div>
{:else if data.fields.formFactor === "Video with Description & Title"}
  <TwoColumnLayout
    columnLayout="symmetric"
    class="gap-32 lg:gap-48  lg:pr-0 embedded-content"
    rightColumnClass="lg:pr-0 lg:w-full order-first lg:order-last"
    leftColumnClass="self-center"
  >
    <YoutubeEmbedDescription slot="left" data={data.fields.items[0]} class="text-size-20 pb-32" />
    <YoutubeEmbed slot="right" data={data.fields.items[0]} />
  </TwoColumnLayout>
{:else if data.fields.formFactor === "Video Playlist"}
  <VideoPlaylist videos={data.fields.items} />
{:else if data.fields.formFactor === "Timeline"}
  <Bleed fullWidth contentClasses="px-24 lg:px-72" class="embedded-content">
    {#each data.fields.items as item}
      <TimelineEvent data={item}>
        <RichText node={item.fields.body} class="!ml-0 font-normal py-8" />
      </TimelineEvent>
    {/each}
  </Bleed>
{/if}
